const categories = [
    {
        name: "Electric",
        subcategories: ["les paul", "stratocaster", "telecaster", "hollow body"]
    },
    {
        name: "Bass",
        subcategories: ["4-string", "5-string", "fretless", "acoustic bass"]
    },
    {
        name: "Acoustic",
        subcategories: ["steel string", "nylon string", "12-string", "travel guitars"]
    },
    {
        name: "Effect",
        subcategories: ["overdrive", "distortion", "delay", "reverb", "chorus"]
    },
    {
        name: "Amp",
        subcategories: ["tube Amps", "solid-state amps", "modeling amps", "cabinets"]
    },
    {
        name: "Acc",
        subcategories: ["straps", "capos", "picks", "strings", "tuners"]
    },
    {
        name: "Recording Gears",
        subcategories: ["audio interfaces", "microphones", "DAWs", "monitors", "headphones"]
    }
];

export default categories;